import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const blogPosts = [
  {
    title: "The Future of AI in Business",
    excerpt: "Discover how artificial intelligence is revolutionizing business operations, from predictive analytics to automated decision-making. Learn about the latest AI trends and their practical applications.",
    image: "https://images.unsplash.com/photo-1485827404703-89b55fcc595e?auto=format&fit=crop&w=600&q=80",
    date: "June 1, 2024",
    readTime: "5 min read",
    category: "AI & Machine Learning",
    author: "Dr. Sarah Chen",
    authorImage: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=100&q=80",
    link: "/blog/future-of-ai"
  },
  {
    title: "Cloud Migration Best Practices",
    excerpt: "Master the art of cloud migration with our comprehensive guide. From planning and execution to optimization, learn how to ensure a smooth transition to the cloud while avoiding common pitfalls.",
    image: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&w=600&q=80",
    date: "May 15, 2024",
    readTime: "7 min read",
    category: "Cloud Computing",
    author: "Michael Rodriguez",
    authorImage: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=100&q=80",
    link: "/blog/cloud-migration"
  },
  {
    title: "DevOps Culture Transformation",
    excerpt: "Transform your organization's development and operations with proven DevOps practices. Learn how to build a collaborative culture that accelerates delivery and improves software quality.",
    image: "https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=600&q=80",
    date: "May 1, 2024",
    readTime: "6 min read",
    category: "DevOps",
    author: "Alex Thompson",
    authorImage: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&w=100&q=80",
    link: "/blog/devops-culture"
  }
];

export const BlogSection = () => {
  return (
    <section className="py-20 px-6 bg-gray-900 dark:bg-gray-950">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-white mb-4">Latest Insights</h2>
          <p className="text-gray-400 max-w-2xl mx-auto">
            Stay updated with our latest articles, insights, and best practices in AI, Cloud, and DevOps.
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-8">
          {blogPosts.map((post, index) => (
            <motion.article
              key={index}
              className="bg-gray-800 rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 flex flex-col"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ y: -5 }}
            >
              <Link to={post.link} className="block">
                <div className="relative">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-48 object-cover"
                  />
                  <span className="absolute top-4 left-4 bg-blue-500 text-white px-3 py-1 rounded-full text-sm">
                    {post.category}
                  </span>
                </div>
              </Link>
              <div className="p-6 flex flex-col flex-grow">
                <div className="flex justify-between text-sm text-gray-400 mb-3">
                  <span>{post.date}</span>
                  <span>{post.readTime}</span>
                </div>
                <h3 className="text-xl font-semibold text-white mb-3 hover:text-blue-400 transition-colors">
                  <Link to={post.link}>{post.title}</Link>
                </h3>
                <p className="text-gray-400 mb-4 line-clamp-3 flex-grow">{post.excerpt}</p>
                <div className="flex items-center justify-between mt-auto">
                  <div className="flex items-center space-x-3">
                    <img
                      src={post.authorImage}
                      alt={post.author}
                      className="w-8 h-8 rounded-full object-cover"
                    />
                    <span className="text-sm text-gray-300">{post.author}</span>
                  </div>
                  <Link to={post.link} className="text-blue-400 hover:text-blue-300 transition-colors font-medium">
                    Read More →
                  </Link>
                </div>
              </div>
            </motion.article>
          ))}
        </div>
        <div className="text-center mt-12">
          <Link to="/blog">
            <motion.button
              className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-3 rounded-lg font-medium transition-colors"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              View All Articles
            </motion.button>
          </Link>
        </div>
      </div>
    </section>
  );
}; 